import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import { Link } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import useComparable from '~/commons/hooks/useComparable';
import PageHttp from '~/commons/components/PageHttp.jsx';
import ListPagination from '~/commons/components/ListPagination.jsx';
import RankingsTitle from './RankingsTitle.jsx';
import UserAvatar from './UserAvatar.jsx';

import { env, lang } from '../../config';

const { grades } = env;

const withins = [
  { key: 'school', label: '學校' },
  { key: 'district', label: '十八區' },
  { key: 'all', label: '全港' },
];

const Rankings = ({
  user,
  filter,
}) => {
  const {
    unitType,
    within,
  } = filter;
  const [res, req, fetched] = useHttpStatus();
  const w = withins.find((i) => i.key === within);
  const { school, schoolClass } = user;
  const limit = 30;
  const [query, setQuery] = useState({
    skip: 0,
    limit,
  });

  const fetch = (q) => {
    const nq = { ...query, ...q };

    setQuery(nq);
    req({
      url: `/api/quiz/rankings/${unitType}/${within}`,
      params: nq,
    });
  };

  useEffect(() => {
    fetch({ skip: 0, limit });
  }, [useComparable(filter)]);

  const pagination = () => fetched && (
    <div className="row justify-content-end">
      <div className="col-auto">
        <ListPagination
          size="sm"
          showTotal={false}
          {...{
            ...query,
            limit,
            total: fetched.total,
            onChange: (p) => fetch(p),
          }}
        />
      </div>
    </div>
  );

  return (
    <div className="container">
      {/* {pagination()} */}
      <PageHttp className="position-relative" res={res}>
        {({ rows, self }) => {
          const schInfo = [];

          if (['school'].includes(within)) {
            schInfo.push(lang(school.title));
          }
          // schoolClass scope removed — no per-class labeling

          // placeholder
          if (!rows.length) {
            return (
              <div className="text-center my-4">
                <Link to="/app/assignments">
                  <img
                    src="/assets/img/no-rank.png"
                    style={{ width: '400px', maxWidth: '100%' }}
                  />
                </Link>
              </div>
            );
          }

          return (
            <div className="text-center">
              <div className="row justify-content-center">
                <div className="col-md-11 col-lg-10 col-xl-9 px-4">
                  <div className="my-3">
                    <RankingsTitle>
                      <span className="mx-3">
                        {w.label}榜
                      </span>
                      {schInfo.join('·')}
                    </RankingsTitle>
                  </div>
                  {self && !!(self.rank + 1) && (
                    <div className="text-center my-3">
                      <div className="
                        row justify-content-center align-items-center
                      ">
                        <div
                          className="col-auto"
                          style={{ width: '100px' }}
                        >
                          {unitType === 'student' ? (
                            <UserAvatar
                              src={user.avatar}
                              active={true}
                            />
                          ) : (
                            <UserAvatar
                              active={true}
                            >
                              <div className="text-white h3 m-0">
                                {user.schoolClass.title}
                              </div>
                            </UserAvatar>
                          )}
                        </div>
                        <div className="col-auto">
                          <h4 className="m-0">
                            我的{
                              self.unitType === 'student'
                                ? '排名'
                                : '團體'
                            }
                          </h4>
                        </div>
                        <div className="col-auto">
                          <button
                            className="btn btn-primary"
                            // onClick={() => {
                            //   fetch({
                            //     skip: Math.floor(self.index / limit) * limit,
                            //   });
                            // }}
                          >
                            第{self.rank + 1}名
                          </button>
                        </div>
                        <div className="col-auto">
                          <h4 className="text-primary">
                            {self.score || 0} 分
                          </h4>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="py-2 text-center">
                    排行榜排名和得分將會在一小時內更新，請稍候。
                  </div>
                  <div className="row mx-n4">
                    {rows.map((r, i) => (
                      <div
                        key={r._id}
                        className={`
                          px-4 pt-4
                          col-6 col-md-${i < 3 && r.rank < 3 ? '4' : '3'}
                        `}
                      >
                        {unitType === 'student' ? (
                          <UserAvatar
                            rank={r.rank}
                            src={r.unit.avatar}
                            active={true}
                          />
                        ) : (
                          <UserAvatar
                            rank={r.rank}
                            active={true}
                          >
                            <div className="text-white display-3">
                              {r.unit.title}
                            </div>
                          </UserAvatar>
                        )}

                        <div className="text-center position-relative mt-n4">
                          <span className="btn btn-light">
                            第{r.rank + 1}名
                          </span>
                          <div>
                            {unitType === 'student' ? (
                              lang(get(r.unit, 'name.full'))
                            ) : (
                              `${r.unit.title}班`
                            )}
                          </div>
                          {!within.includes('school') && (
                            <div>{lang(r.unit.school.title)}</div>
                          )}
                          <h3 className="text-primary">
                            {r.score || 0} 分
                          </h3>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </PageHttp>
      {/* {res.status === 'success' && pagination()} */}
    </div>
  );
};

export default Rankings;
